var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="survey-item__checkbox">\n  <i class="icon--checkmark icon--auto-width"></i>\n</div>\n<div class="survey-item__option-label">'+
((__t=( value ))==null?'':_.escape(__t))+
'</div>\n';
}
return __p;
};
